// extracted by mini-css-extract-plugin
export default {"wrapper":"Observer_wrapper__0ObHu","observer":"Observer_observer__ORzNZ"};